/** Plain-language state for a bank statement's posting action. */
export interface StatementPostingSummary {
  total: number;
  posted_own: number;
  posted_matched: number;
  no_posting: number;
  missing: number;
}

export type PostingStatus = 'confirm' | 'post_missing' | 'posted' | 'nothing';

/** Which primary action the statement header should offer. */
export function postingStatus(
  status: string | null | undefined,
  summary: StatementPostingSummary | null | undefined,
): PostingStatus {
  if (!status || ['needs_review', 'extracted', 'draft'].includes(status)) return 'confirm';
  if (!summary) return 'nothing';
  if ((summary.missing || 0) > 0) return 'post_missing';
  if (((summary.posted_own || 0) + (summary.posted_matched || 0)) > 0) return 'posted';
  return 'nothing';
}
